import { DpCouponBar } from '@/components/blocks/DpLibrary/DpCouponBar';
import { DpMemberPromotionRender } from '@/components/blocks/DpMemberPromotionRender';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { PERSONALIZATION_LANDING_PATH } from '@/data/Content/RepurchaseCoupon';
import { useLocalization } from '@/data/Localization';
import { useUser } from '@/data/User';
import {
	buildDppLandingHref,
	getDppFirstName,
	getDppRedeemableTimeLeft,
} from '@/utils/dppPromotion';
import { Box } from '@mui/material';

type DpDppCouponBarProps = {
	href?: string;
	button?: string;
	fallbackcontent?: string | null;
};

const useDppBarPage = () => {
	const { query } = useNextRouter();
	const { Cart, CheckOut, CheckOutBanamexEvo } = useLocalization('Routes');
	const path = [query.path ?? []].flat();
	const identifier = path.at(-1) ?? '';
	return {
		isHome: !path.length,
		hidden: [
			Cart.route.t(),
			CheckOut.route.t(),
			CheckOutBanamexEvo.route.t(),
			PERSONALIZATION_LANDING_PATH,
		].includes(identifier),
	};
};

/**
 * Barra superior con el cupón DPP del cliente con sesión. Si no hay cupón que se pueda usar,
 * en el home muestra el espot de fallbackcontent (la barra de promoción genérica) o nada si no se envía.
 */
export const DpDppCouponBar = ({ href, button, fallbackcontent = null }: DpDppCouponBarProps) => {
	const { user } = useUser();
	const { isHome, hidden } = useDppBarPage();
	const firstName = getDppFirstName(user?.firstName);
	// Un atributo vacío en el HTML llega como true, no como string.
	const emsName = typeof fallbackcontent === 'string' ? fallbackcontent.trim() : '';
	const fallback =
		isHome && emsName ? (
			<ContentRecommendation
				id={emsName}
				properties={{ emsName }}
				withoutFrame
				loadingElement={<Box />}
			/>
		) : null;

	if (hidden) {
		return null;
	}

	return (
		<DpMemberPromotionRender
			emptyElement={fallback}
			renderData={(promotion) => {
				const expiration = getDppRedeemableTimeLeft(promotion);
				if (!expiration) {
					return fallback;
				}
				return (
					<DpCouponBar
						name={firstName}
						discount={`${promotion.discountPercent}%`}
						expiration={expiration}
						button={button}
						href={href ? buildDppLandingHref(href, promotion, firstName) : undefined}
					/>
				);
			}}
		/>
	);
};
